<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.3603265625,4.59C13.2103265625,3.46,13.8603265625,2.58,14.4603265625,1.72C14.4603265625,1.72,13.4303265625,0.53,13.4303265625,0.53C11.7103265625,1.41,9.3103465625,1.18,7.8003465625,0C6.2903465625,1.18,3.8903465625,1.41,2.1703465625,0.52C2.1703465625,0.52,1.1403465625,1.72,1.1403465625,1.72C1.7503465625,2.58,2.3903465625,3.46,2.2403465625,4.59C1.9403465625,6.88,-0.20965343749999998,8.76,0.9203465625,11.27C1.3703465625,12.41,2.3603465625,13.17,3.6403465625,13.47C5.2003465625,13.83,7.1603465625,14.19,7.8003465625,16C8.4403465625,14.19,10.4003465625,13.84,11.9603265625,13.46C13.2403265625,13.16,14.2303265625,12.4,14.6803265625,11.26C15.8003265625,8.76,13.6503265625,6.88,13.3603265625,4.59C13.3603265625,4.59,13.3603265625,4.59,13.3603265625,4.59Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Badge',
} as DefineComponent
</script>
